module.exports = require("inversify");;